import { render, staticRenderFns } from "./RbDialog.vue?vue&type=template&id=6f7fa265&scoped=true"
import script from "./RbDialog.vue?vue&type=script&lang=js"
export * from "./RbDialog.vue?vue&type=script&lang=js"
import style0 from "./RbDialog.vue?vue&type=style&index=0&id=6f7fa265&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7fa265",
  null
  
)

export default component.exports